// extracted by mini-css-extract-plugin
export default {"App":"App_App__v1cQL","routersContainer":"App_routersContainer__wcPQp"};